// extracted by mini-css-extract-plugin
export default {"iframeContainer":"AVLabGame_iframeContainer__PZ6d6","iframe":"AVLabGame_iframe__OUmx+","pageWrapper":"AVLabGame_pageWrapper__5bX8I"};